// eslint-disable-next-line import/extensions
import { FormattedMessage } from 'umi/locale';
import React, { PureComponent } from 'react';
import { Spin, Menu, Avatar, Dropdown } from 'antd';
import Debounce from 'lodash-decorators/debounce'
import { handleUserAgent } from '@/utils/utils'
import styles from './index.less';

export default class BascHeaderRight extends PureComponent {
  constructor() {
    super();
    this.state = {
    }
  }


  componentWillUnmount() {
    this.triggerResizeEvent.cancel();
  }
  /* eslint-disable*/
  @Debounce(600)
  triggerResizeEvent() {
    // eslint-disable-line
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    window.dispatchEvent(event);
  }

  toggle = () => {
    const { collapsed, onCollapse } = this.props;
    onCollapse(!collapsed);
    this.triggerResizeEvent();
  };

  render() {
    const { currentUser, onMenuClick, theme, schools = [],sloganUrl } = this.props;
    const isWxwork = handleUserAgent();

    const menu = !isWxwork ? (
      <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
        {
          schools && schools.length > 2 ? <Menu.Item key="selectSchool">
            <FormattedMessage id="menu.account.selectSchool" defaultMessage="身份切换" />
          </Menu.Item> : ''
        }
        <Menu.Item key="logout">
          <FormattedMessage id="menu.account.logout" defaultMessage="退出登录" />
        </Menu.Item>
      </Menu>
    ) : <></>;
    let className = styles.right;
    if (theme === 'dark') {
      className = `${styles.right}  ${styles.dark}`;
    }
    return (
      <div className={className}>
        {
          sloganUrl && <span className={styles.sloganUrl}><img src={sloganUrl} /> <span className='line'>|</span></span>
        }
        {currentUser.name ? (
          <Dropdown overlay={menu}>
            <span className={`${styles.action} ${styles.account}`}>
              <Avatar
                size="small"
                className={styles.avatar}
                src={currentUser.avatar}
                alt="avatar"
              />
              <span className={styles.name}>{currentUser.name}</span>
            </span>
          </Dropdown>
        ) : (
            <Spin size="small" style={{ marginLeft: 8, marginRight: 8 }} />
          )}
      </div>
    );
  }
}
